<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    const IdmModSemi = defineAsyncComponent(() => import('../components/oferta/IdmModSemi.vue')) ;
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue';
</script>

<template class="bg-white">
    <TopBannerLeft
        :img="'background-image: url(/pagesImages/head-ingles.jpg);'"
        :engop1="'English'"
        :engop2="'Kingdom'"
        :engop3="'Think in English'"
        :engop4="'Certificado por la Universidad de Cambridge.'"
    />

    <!-- Certificado -->
    <div class="flex items-center justify-center w-full mb-16">
        <div class="flex flex-col lg:flex-row justify-center w-full items-center max-w-[1200px]">
            <img src="/pagesImages/piramide-ingles-english-kingdom.jpg" alt="Pirámide de nivel de inglés" loading="lazy" class="lg:mr-12 mb-6 lg:mb-0 max-w-[500px]">
            <div class="flex flex-col  justify-center md:items-start items-center">
                <h2 class="text-left">
                    <span class="block text-left leading-none lg:px-0 px-4 text-[28px]">Clases de inglés de</span>
                    <span class="sr-only whitespace-nowrap">&nbsp;</span>
                    <span class="block text-hgold text-left lg:px-0 px-4 lg:text-[42px] text-[36px] font-serif mb-6">English Kingdom</span>
                </h2>
                <p class="text-justify lg:px-0 px-4">Las clases de inglés de English Kingdom son la mejor opción, ya que cuentan con un método efectivo y personalizado.</p>
                <br>
                <p class="text-justify lg:px-0 px-4">En English Kingdom, hemos diseñado nuestros cursos bajo los más altos estándares internacionales, siguiendo la estructura del Marco Común Europeo de Referencia para Idiomas.</p>
                <br>
                <p class="text-justify lg:px-0 px-4">Nuestra metodología se centra en el enfoque comunicativo por competencias, garantizando que los estudiantes utilicen el idioma inglés como una herramienta poderosa en los ámbitos de su vida: académico, profesional y personal.</p>
            </div>
        </div>
    </div>

    <section class="flex flex-col items-center w-full justify-center mb-16">
        <div class="flex w-full items-center justify-center">
            <div class="flex flex-col items-center w-full max-w-4xl lg:max-w-[1200px] px-4">
                <h2 class="font-serif md:text-[36px] text-3xl leading-tight text-hgold mb-8">
                    Ventajas de las clases<br class="md:block vhidden" /><span class="sr-only whitespace-nowrap">&nbsp;</span>
                    de inglés English Kingdom
                </h2>
                <div class="lg:flex items-center justify-center hyphens-auto">
                    <div class="lg:w-[50%] text-justify mb-10 lg:mb-0 lg:mr-12">
                        <h3 class="mt-4 mb-2 text-left text-lg uppercase">Desarrollo integral de habilidades</h3>
                        <p>
                            Potenciamos las cuatro competencias clave: expresión oral, comprensión auditiva, lectura y escritura, para que domines el inglés de manera efectiva y natural.
                        </p>
                        <br />
                        <h3 class="mt-4 mb-2 text-left text-lg uppercase">Certificaciones de prestigio</h3>
                        <p class="">
                            Otorgamos certificaciones reconocidas globalmente, avaladas por la Universidad de Cambridge, que abren puertas en el mundo académico y laboral.
                        </p>
                        <br />
                        <h3 class="mt-4 mb-2 text-left text-lg uppercase">Enfoque práctico y personalizado</h3>
                        <p>
                            Nuestros cursos están diseñados para múltiples objetivos, ya sea para estudiar en el extranjero, reforzar la carrera profesional o comunicarse con confianza.
                        </p>
                    </div>
                    <div class="flex items-center justify-center">
                        <img src="/pagesImages/english-kingdom-mujer.webp" alt="alt pendiente" />
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section class="flex items-center justify-center w-full mb-16">
        <div class="flex flex-col w-full items-center justify-center">
            <h2 class="text-center">
                <span class="block text-center leading-none lg:px-0 px-4 text-[28px]">Niveles y tipos de</span>
                <span class="sr-only whitespace-nowrap">&nbsp;</span>
                <span class="block text-hgold text-center lg:px-0 px-4 lg:text-[42px] text-[36px] font-serif mb-6">certificaciones de inglés</span>
            </h2>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8 hyphens-auto">
                <div class="flex items-center justify-center">
                    <img src="/pagesImages/icono-ket-ingles.jpg" loading="lazy" alt="Icono KET 1" class="max-h-[120px] mr-8">
                    <div class="text-justify hyphens-auto">
                        <h3 class="mb-1 text-lg uppercase font-semibold">KET 1</h3>
                        <p>Key English Test <br>Es una certificación de nivel básico para comunicarse en situaciones sencillas, logrando una buena base en el aprendizaje de inglés.</p>
                    </div>
                </div>
                <div class="flex items-center justify-center">
                    <img src="/pagesImages/icono-pet-ingles.jpg" loading="lazy" alt="Icono PET 2" class="max-h-[120px] mr-8">
                    <div class="text-justify hyphens-auto">
                        <h3 class="mb-1 text-lg uppercase font-semibold">PET 2</h3>
                        <p>Preliminary English Test <br>Implica conocer el idioma a nivel práctico y de uso diario, además de aprobar un examen básico-intermedio de inglés cotidiano.</p>
                    </div>
                </div>
                <div class="flex items-center justify-center">
                    <img src="/pagesImages/icono-fce-ingles.jpg" loading="lazy" alt="Icono FCE 3" class="max-h-[120px] mr-8">
                    <div class="text-justify hyphens-auto">
                        <h3 class="mb-1 text-lg uppercase font-semibold">FCE 3</h3>
                        <p>First Certificate in English <br>Es una valiosa certificación para alumnos en su trayectoria académica, que buscan alcanzar un nivel intermedio-avanzado.</p>
                    </div>
                </div>
                <div class="flex items-center justify-center">
                    <img src="/pagesImages/icono-cae-ingles.jpg" loading="lazy" alt="Icono CAE 4" class="max-h-[120px] mr-8">
                    <div class="text-justify hyphens-auto">
                        <h3 class="mb-1 text-lg uppercase font-semibold">CAE 4</h3>
                        <p>Certificate in Advance English <br>Certificación nivel universitario, equiparable para trabajar a nivel gerencial dentro de un entorno internacional de negocios. Nivel Avanzado.</p>
                    </div>
                </div>
                <div class="flex items-center justify-center">
                    <img src="/pagesImages/icono-ielts-ingles.jpg" loading="lazy" alt="Icono IELTS 5" class="max-h-[120px] mr-8">
                    <div class="text-justify hyphens-auto">
                        <h3 class="mb-1 text-lg uppercase font-semibold">IELTS 5</h3>
                        <p>International English Language Testing System <br>Certificación para alumnos que mide el dominio del idioma inglés a través de la evaluación de las diferentes habilidades, incrementando las oportunidades tanto a nivel personal como profesional en su propio país o a nivel internacional.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <IdmModSemi />
</template>

<style>

</style>